import {CanMatchFn} from '@angular/router';

export const PERFORMANCE_FIXTURE_STATES = ['complete', 'incomplete', 'empty', 'error', 'loading'] as const;
export type PerformanceFixtureState = typeof PERFORMANCE_FIXTURE_STATES[number];
export function readPerformanceFixture(href: string): PerformanceFixtureState | null {
  try {
    const url = new URL(href);
    const state = url.searchParams.get('performanceFixture');
    return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password &&
      ['localhost', '127.0.0.1', '[::1]'].includes(url.hostname) && url.pathname === '/performance/review' &&
      url.searchParams.getAll('performanceFixture').length === 1 &&
      PERFORMANCE_FIXTURE_STATES.includes(state as PerformanceFixtureState) ? state as PerformanceFixtureState : null;
  } catch { return null; }
}
export const performanceFixtureCanMatch: CanMatchFn = () => typeof window !== 'undefined' && readPerformanceFixture(window.location.href) !== null;
